const Title = ({title, subtitle}) => {

    return (
        <div className="py-2 shadow-lg mb-2 text-center">
            <h1 className="text-2xl font-bold uppercase">
                {title}
            </h1>
            {subtitle && <h4 className="text-sm">
                {subtitle}
            </h4>}
        </div>
    );
};

export default Title;